export const LA_CUISINES_EXPERIMENT = 'new-chefs-cuisines-la'
export const MENU_SORTING_HACK_EXPERIMENT = 'menu-sorting-logic'
export const MEAL_CARD_PRICE_EXPERIMENT = 'meal-card-price-experiment'
export const NEW_PICTURES_SEATTLE_EXPERIMENT = 'new-pictures-seattle-experiment'

export const FIVE_MILESTONE_CHALLENGE_EXPERIMENT = {
  id: 'gtt-4143',
  name: 'Growth - Activation - 5 Milestones Challenge',
  unleash: 'FIVE_MILESTONE_CHALLENGE'
}

export const FF_OFFER_BANNER_EXPERIMENT = {
  id: 'gro-sc-4312',
  name: 'Growth - Activation - Add Promo Banner Orders',
  unleash: 'OFFER_BANNER_EXPERIMENT'
}

export const FF_SKIP_DEFLECTION_STRATEGY_EXPERIMENT = {
  id: 'gro-sc-4170',
  name: 'Growth - Activation - Skip Option More Visible',
  unleash: 'SKIP_DEFLECTION_STRATEGY'
}
